<template>
  <div @click="click" class="Top" :class="{ 'is-custom': $root.customHeader }">
    <template v-if="$root.customHeader">
      <img class="Top__logo" :src="require('./img/onf.png')" />
      <div class="Top__fullscreen" @click="setFullscreen">
        <img :src="require('./img/enlarge.png')" />
      </div>
      <div class="Top__lang" @click="changeLang(lang == 'fr' ? 'en' : 'fr')">
        {{ lang == 'fr' ? 'en' : 'fr' }}
      </div>
    </template>
  </div>
</template>

<script>
import Settings from '@/config/Settings'

export default {
  name: 'Top',
  watch: {
    '$route': 'checkRoute',
    vr: 'toggle',
    fullscreen: 'toggle'
  },
  mounted() {
    document.body.classList.add("roxham")

    if(this.$root.customHeader)
      return

    if(this.$root.noheader)
       document.body.classList.add("noheader")

    const base_url = {
      fr: window.location.protocol + '//' + Settings.onfUrl.fr,
      en: window.location.protocol + '//' + Settings.onfUrl.en,
    }

    load_framework.init({
      currentProjectId: 154,
      displaySoundToggle: false,
      base_url: base_url
    })

    setTimeout(() => {
      _.each(Settings.ua_code, code => {
        window.google_analytics.gaTrack({ language: this.lang, name: "begin", ua_code: code, event: "auto_begin" })
      })
    }, 1000 * 10)

    this.$nextTick(() => this.checkRoute())
  },
  methods: {
    changeLang(lang) {
      this.$store.commit('app/RESET', lang)
      this.$router.push({ name: 'load.' + lang })
    },
    setFullscreen() {
      const element = document.documentElement
      if(element.requestFullscreen) {
        element.requestFullscreen()
      } else if(element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if(element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if(element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
    },
    click() {
      // if(this.$root.$agent.mobile) {
      //   this.$router.push({ name: 'load.' + this.lang })
      //   TweenMax.delayedCall(1, () => location.reload())
      // } 
    },
    toggle() {
		  let show = true
			// const isBeginPage = ['lock', 'load', 'infos', 'wait'].indexOf(this.$route.meta.name) > -1

      if(this.vr || this.fullscreen)
        show = false

			TweenMax.to('#interactive-header, .Top', 1, { y: show ? 0 : -100  })
    },
		checkRoute() {
      if(this.$root.customHeader)
        return

      const routeName = this.$route.meta.name
      const captation = this.$route.params.captation

      if(window.google_analytics && typeof window.google_analytics.gaTrack == 'function')
        _.each(Settings.ua_code, code => {
          window.google_analytics.gaTrack({
            language: this.lang,
            name: 'roxham',
            ua_code: code,
            pageview: location.pathname
          })
        })
		}
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

body.noheader
  #interactive-header
    #case-study-link
    #lang-switch-link
    .social-icons
    #grid-link
    .header-logo
      display none

body.roxham
  .a-orientation-modal
    button
      position absolute
      top constant(safe-area-inset-top)
      top env(safe-area-inset-top)

  #containerOverlay
    position fixed
    z-index 98
    -webkit-overflow-scrolling touch
    overflow auto

  #interactive-header
    +max-screen(phone)
      height 45px !important

    #case-study-link
      +max-screen(phone)
        display none


.Top
	position fixed
	top 0px
	left 0px
	right 0px
	display none

.Top.is-custom
  display block
  background white
  height 50px
  z-index 9999999
  border-bottom 1px solid #d8d9db
  +max-screen(phone)
    display none

.Top__logo
  height 20px
  display block
  margin 15px auto

.Top__fullscreen
  height 50px
  width 50px
  padding 15px
  border-left 1px solid #d8d9db
  position absolute
  right 0px
  top 0px
  cursor pointer
  +max-screen(phone)
    display none

.Top__lang
  width 50px
  border-left 1px solid #d8d9db
  position absolute
  right 50px
  top 0px
  cursor pointer
  color black
  line-height 50px
  text-transform uppercase
  text-align center
  font-size 12px
  +max-screen(phone)
    right 0px


</style>



// WEBPACK FOOTER //
// src/components/top/Top.vue